import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';

import './BorrowingUtilityBarTitle.scss';

const getMessageKeyForTitle = (status) => {
  if (status) {
    return `borrowing_item_count_${status.toLowerCase()}`;
  }

  return 'borrowing_item_count_all';
};

const getTitle = (status, count, appendColon) => {
  const key = getMessageKeyForTitle(status);

  if (appendColon) {
    return (
      <FormattedMessage id={key} values={{ count }}>
        {
          (title) => <FormattedMessage id="title_with_colon" values={{ title }} />
        }
      </FormattedMessage>
    );
  }

  return <FormattedMessage id={key} values={{ count }} />;
};


export default function BorrowingUtilityBarTitle({ status, statusIcon, count, appendColon }) {
  const classNames = cn(
    'cp-borrowing-utility-bar-title',
    status ? status.toLowerCase() : ''
  );

  return (
    <span className={classNames}>
      {statusIcon ?
        <div className="status-icon-wrapper">{statusIcon}</div> :
        null
      }
      <h2>{getTitle(status, count, appendColon)}</h2>
    </span>
  );
}

BorrowingUtilityBarTitle.propTypes = {
  status: PropTypes.string,
  statusIcon: PropTypes.element,
  count: PropTypes.number,
  appendColon: PropTypes.bool
};

BorrowingUtilityBarTitle.defaultProps = {
  appendColon: false
};



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/BorrowingUtilityBarTitle/BorrowingUtilityBarTitle.jsx